import { render } from "./AppHeader.vue?vue&type=template&id=f8c21d3c"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/sentry/temp/sensoren/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__